import {columnGrid} from '../../../utils/lunchGrid/ColumnGrid'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import {callSP} from '../../../../setup/axios/AxiosCallSP'
import {dataMinuta} from '../minutaFood/minutaDTO'
import {fotmatDateHeader, getLStorage, setLStorage} from '../../../../global.d'
import {ColDef, ColGroupDef} from 'ag-grid-community'
import {itemSelec} from './Grilla1'
import {getUserByToken} from 'app/helpers/getUserByToken'

export let version = '2'
let timerSave: any = null

const openPopUp = (params: any) => {
  params.data.open = true
}

export const getDataRowStorage = () => {
  return localStorage.getItem('dataRow')
}

export const onAddData = (
  addData: boolean,
  datar: any,
  getDataRow: any,
  setLStorage: any,
  setDataRowB: any
) => {
  if (addData) {
    datar.unshift(getDataRow[0])
    setLStorage('dataRow', datar)
    setDataRowB(datar[0])
  }
}

export const changeAutocompleteGrid = async (
  params: any,
  parameters: any,
  setParameters: any,
  setShowModalMenu: any,
  setLStorage: any,
  setDataRowB: any
) => {
  const ing = await localStorage.getItem('ingredienteSeleccionado2')
  if (ing !== null) {
    const datarow = await getDataRowStorage()
    if (datarow !== null) {
      const data: itemSelec = JSON.parse(ing)
      let addData = false
      let getDataRow = JSON.parse(datarow)
      const datar = JSON.parse(datarow)
      const rec_codigo = params.data ? params.data.rec_codigo : params.rec_codigo
      const rec_nombre = params.data ? params.data.rec_nombre : params.rec_nombre
      getDataRow[0].forEach((item: any, key: number) => {
        if (item['fecha' + data.idColumn] === data.fecha && data.numRow === key) {
          if (
            item['id_receta' + data.idColumn] !== rec_codigo &&
            item['receta' + data.idColumn] !== rec_nombre
          ) {
            item['id_receta' + data.idColumn] = rec_codigo
            item['receta' + data.idColumn] = rec_nombre
            item['className' + data.idColumn] = 'ultimo-cambio'

            const p = parameters
            const pSelected = getLStorage('parameterSelected')
            if (pSelected) {
              const finded = p.find((e: any) => e.id === pSelected?.id)
              if (finded === undefined) {
                p.push({
                  id: pSelected?.id,
                  id_receta: rec_codigo,
                  ponderado: pSelected?.ponderado,
                })
              } else {
                const index = p.findIndex((e: any) => e.id === pSelected?.id)
                finded.id_receta = rec_codigo
                p.splice(index, 1, finded)
              }
              setParameters(p)
            }

            addData = true
          }
        }
      })
      onAddData(addData, datar, getDataRow, setLStorage, setDataRowB)
    }
  }
  setShowModalMenu(false)
}

const updateComensales = async (
  idContrato: any,
  nroVersion: any,
  dia: any,
  ciclo: any,
  comensales: any
) => {
  const response: any = await callSP('amd_updateComensales', [
    {text: 'contrato', value: idContrato.toString()},
    {text: 'version', value: nroVersion.toString()},
    {text: 'dia', value: dia.toString()},
    {text: 'ciclo', value: ciclo.toString()},
    {text: 'comensales', value: comensales.toString()},
  ])
  if (response.status === 200) {
    // setDatosContrato(response.data.result)
  }
}

export const calculoAjustes = (dataRowP: any, columns: any, setDataRowP: any) => {
  let costoBandejaPlanificado = 0
  let costoBandejaAjustadoOperacion = 0
  let alzaBajaCostoBandejaUnit = 0
  let incrementoReduccionCostoTotal = 0
}

export const costoAjustado = (
  datarow: any,
  dataRowP: any,
  columns: any,
  params: any,
  setDataRowP: any
) => {
  const [dataColum] = columns
    .filter((itemCol: any) => itemCol.key.indexOf('receta') > -1)
    .map((itemCol: any) =>
      datarow.map((itemRow: any) =>
        itemRow.map((item: any) => {
          if (item[`fecha${itemCol.id}`] === itemCol.text) {
            return item
          }
        })
      )
    )
  //TODO: Validar la data de params
  const sumatoria = (id: number) => {
    const ponderar = (acc: number, num: any) =>
      acc + (parseInt(num[`ponderado${id}`], 0) / 100) * parseInt(num[`ctoPlato${id}`], 0)
    return dataColum[0].reduce(ponderar, 0)
  }

  columns.forEach((itemCol: any, keyCol: number) => {

    if (itemCol.key.indexOf('receta') > -1) {


      dataRowP[1][`id_receta${itemCol.id}`] = sumatoria(itemCol.id).toFixed(2)
      dataRowP[2][`id_receta${itemCol.id}`] = (
        sumatoria(itemCol.id) - dataRowP[2][`cto_plato${itemCol.id}`]
      ).toFixed(2)

      setDataRowP(dataRowP)
    }
  })
}

const renderDiff = (diff: number) => {
  if (!diff) {
    return <span>{diff}</span>
  }

  if (diff > 0) {
    return <span className='error'>{'🡅 ' + diff}</span>
  }

  return <span className='success'>{'🡇 ' + -1 * diff}</span>
}

export const changeInputGrid = async (event: any, params: any, setDataRowB: any, colum: any) => {
  clearTimeout(timerSave)
  timerSave = setTimeout(async () => {
    if (event.target.value === '') {
      return
    }
    const datarow = await getDataRowStorage()
    if (datarow !== null) {
      if (params.column !== undefined) {
        let addData = false
        let getDataRow = JSON.parse(datarow)
        const datar = JSON.parse(datarow)
        const idColumn = params.column.colId.charAt(params.column.colId.length - 1)
        const pSelected = {
          id: params.data['id' + idColumn],
          id_receta: params.data['id_receta' + idColumn],
          ponderado: params.data['ponderado' + idColumn],
          fecha: params.data['fecha' + idColumn],
          numRow: params.rowIndex,
          idColumn: idColumn,
          dia: params.data['dia' + idColumn],
          ciclo: params.data['ciclo' + idColumn],
          cantidad_comensales: event.target.value, // params.data['cantidad_comensales' + idColumn],
        }

        setLStorage('parameterSelected', pSelected)

        getDataRow[0].forEach((item: any, key: number) => {
          if (
            item['fecha' + idColumn] === params.data['fecha' + idColumn] &&
            params.rowIndex === key
          ) {
            if (item['cantidad_comensales' + idColumn] !== parseInt(event.target.value)) {
              item['cantidad_comensales' + idColumn] = event.target.value
              item['className' + idColumn] = 'ultimo-cambio'
              updateComensales(
                '2',
                '2',
                pSelected.dia,
                pSelected.ciclo,
                pSelected.cantidad_comensales
              )

              addData = true
            }
          }
        })
        onAddData(addData, datar, getDataRow, setLStorage, setDataRowB)
      }
    }
  }, 1000)
  // }
}

export const quitarDuplicadoReceta = (arrayOptions: any, field: string = 'rec_codigo') => {
  let arrayFilter: any[] = []
  let ideCod: any[] = []
  if (Array.isArray(arrayOptions)) {
    arrayOptions.map((item: any) => {
      if (!ideCod.includes(item[field])) {
        ideCod.push(item[field])
        arrayFilter.push(item)
      }
    })
    return arrayFilter
  } else return []
}

export const autoComplete = (
  funcGrilla: any,
  className: string,
  id: any,
  dataSP: any,
  idReceta: number,
  params: any,
  filters?: any
) => {
  const rec: any = dataSP.find((item: any) => item.rec_codigo == idReceta)
  let arrayOptions: any = []
  arrayOptions = filters
    ? dataSP.filter(
        (e: any) =>
          e.Idtipoingprincipal === filters.Idtipoingprincipal &&
          e.id_alergeno === filters.id_alergeno &&
          e.id_sellos === filters.id_sellos &&
          e.id_estilo_aliminatacion === filters.id_estilo_aliminatacion
      )
    : dataSP
  const arrayFilter = quitarDuplicadoReceta(arrayOptions)
  params.data.parameter = {
    dataSP: arrayFilter,
    params: params,
    dataSelected: rec,
  }
  params.data.open = false
  params.data.idAutoComplete = id + 'p' + Math.floor(Math.random() * 1000)
  return (
    <>
      <Autocomplete
        key={params.data.idAutoComplete}
        id={params.data.idAutoComplete}
        className={className}
        size='small'
        options={params.data.parameter.dataSP}
        getOptionLabel={(option) => option.rec_nombre}
        onClick={(item) => {
          params.data.open = false
        }}
        onChange={(item: any, value) => {
          const idColumn = params.column.colId.charAt(params.column.colId.length - 1)
          const json = {
            idIngrediente: value.Idtipoingprincipal,
            id_grupo_estructura: value.id_grupo_estructura,
            id_receta: value.rec_codigo,
            fecha: params.data['fecha' + idColumn],
            idColumn: idColumn,
            numRow: params.rowIndex,
            id_alergeno: params.data['id_alergeno' + idColumn],
            id_categoria_dietetica: params.data['id_categoria_dietetica' + idColumn],
            id_estilo_aliminatacion: params.data['id_estilo_aliminatacion' + idColumn],
            id_intolerancia: params.data['id_intolerancia' + idColumn],
            id_sellos: params.data['id_sellos' + idColumn],
          }
          setLStorage('ingredienteSeleccionado2', json)
          changeAutocompleteGrid(
            value,
            funcGrilla.parameters,
            funcGrilla.setParameters,
            funcGrilla.setShowModalMenu,
            funcGrilla.setLStorage,
            funcGrilla.setDataRowB
          )
        }}
        defaultValue={params.data.parameter.dataSelected}
        renderInput={(params) => <TextField {...params} variant='outlined' />}
      />
      <i
        key={id + 't' + Math.floor(Math.random() * 1000)}
        className='bi bi-search search-receta'
        onClick={() => {
          params.data.open = true
          params.data.dataSelected = params.data.parameter.dataSelected
          return openPopUp(params)
        }}
      ></i>
    </>
  )
}

const getDataColum = async (idContrato: string, accessToken: any, setEstructuraPadre: any, dataContato?: any, idMinuta?: any) => {
  const user: any = await getUserByToken(accessToken)
  if (user.role.toString() == 8 || user.role.toString() == 12) {
    version = '3'
  }
  if (user.role.toString() == 9 || user.role.toString() == 10) {
    version = '4'
  }

  if (user.role.toString() == 13) {
    version = '2'
  }
  const dataColumRow: any = await callSP('amd_getEstructuraByContrato', [
    {text: 'contrato', value: idContrato},
  ])
  const dataHeader: any = await callSP('amd_getCabeceraMinutaByContrato', [
    {text: 'contrato', value: idContrato},
    {text: 'version', value: version},
    {text: 'id_minuta', value: idMinuta},
  ])
  const dataRow: any = await callSP('amd_getMinutaByContrato', [
    {text: 'contrato', value: idContrato},
    {text: 'version', value: dataContato?.versionMinuta.toString()},
    {text: 'id_minuta', value: idMinuta},
  ])
  const date = dataHeader.data.result.map((item: any) => {
    return {
      fecha: fotmatDateHeader(item.fecha),
      data: item,
    }
  })

  let dataEstrucure: any = []
  dataColumRow.data.result.map((item: any) => {
    if (dataEstrucure[item.id_estructura] === undefined) {
      dataEstrucure[item.id_estructura] = 0
    }
    dataEstrucure[item.id_estructura] += 1
  })
  setEstructuraPadre(dataEstrucure)
  dataColumRow.data.result.map((item: any) => {})
  dataRow.data.result.forEach((item: any) => {
    item.fecha = fotmatDateHeader(item.fecha)
  })
  const dataMinuta: dataMinuta = {
    header: date,
    columRow: dataColumRow.data.result,
    dataRow: dataRow.data.result,
    dataCabecera: dataHeader.data.result,
  }
  return dataMinuta
}

function formatNumber(params: any) {
  let number = params.value * 1
  return Math.floor(number)
    .toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
}

const armarColumGrid = (
  colum: columnGrid[],
  dataSP: any,
  funcGrilla: any,
  setDataRowB?: any
) => {

  const currentColumns = colum.map((item, key) => {
    if (key === 0) {
      return {
        key: key,
        field: item.key,
        headerName: item.text,
        minWidth: 175,
        pinned: 'left',
      }
    } else if (item.key.indexOf('receta') > -1) {
      return {
        key: key,
        field: item.key,
        headerName: item.text,
        minWidth: 300,
        cellRenderer: (params: any) => {
          const key = item.key + Math.floor(Math.random() * 1000)
          if (params.data['receta' + item.id] !== undefined) {
            if (params.data['id_receta' + item.id] !== undefined) {
              params.data.isDefaultValue = false
              if (params.data.cabecera) {
                if (params.data.nombreEstructura === 'Comensales') {
                  return (
                    <input
                      key={item.key}
                      type={'number'}
                      className='form-control'
                      defaultValue={params.data['cantidad_comensales' + item.id]}
                      onChange={(event) => changeInputGrid(event, params, setDataRowB, colum)}
                    />
                  )
                } else if (params.data.nombreEstructura === 'Costo Planificado') {
                  return <>{params.data['cto_plato' + item.id]}</>
                } else if (params.data.nombreEstructura === 'Diferencial') {
                  return renderDiff(params.data['id_receta' + item.id])
                } else {
                  return <>{params.data['id_receta' + item.id]}</>
                }
              } else {
                return autoComplete(
                  funcGrilla,
                  params.data['className' + item.id],
                  key,
                  dataSP,
                  params.data['id_receta' + item.id],
                  params,
                  {
                    id_grupo_estructura: params.data['id_grupo_estructura' + item.id],
                    Idtipoingprincipal: params.data['idIngredientePrincipal' + item.id],
                    id_alergeno: params.data['id_alergeno' + item.id],
                    id_estilo_aliminatacion: params.data['id_estilo_aliminatacion' + item.id],
                    id_intolerancia: params.data['id_intolerancia' + item.id],
                    id_sellos: params.data['id_sellos' + item.id],
                    rec_codigo: params.data['rec_codigo' + item.id],
                  }
                )
              }
            }
          } else {
            return <></>
          }
        },
      }
    } else if (item.key.indexOf('ponderado') > -1) {
      return {
        field: item.key,
        headerName: item.text,
        cellClass: (params2: any) => {},
        minWidth: 120,
        editable: true,
        cellValueChanged: (params: any) => {
        },
      }
    } else if (item.key.indexOf('ctoPlatoPonderado') > -1) {
      return {
        field: item.key,
        headerName: item.text,
        minWidth: 120,
        valueGetter: 'data.ponderado' + item.id + '*1/100 * data.ctoPlato' + item.id + '*1',
        valueFormatter: formatNumber,
      }
    } else if (item.key.indexOf('cto_plato') > -1) {
      return {
        field: item.key,
        headerName: item.text,
        minWidth: 120,
        valueFormatter: formatNumber,
      }
    } else {
      return {
        field: item.key,
        headerName: item.text,
        minWidth: 120,
        cellRenderer: (params: any) => {
          if (params.data['head']) {
            return <></>
          }
          return <>{params.data[item.key]}</>
        },
      }
    }
  })

  const newColumn = {
    key: 'estructura',
    field: 'estructuraPadre',
    headerName: 'padre',
    minWidth: 200,
    pinned: 'left',
    cellRenderer: (params: any) => {
      if (!params.data.hidden) {
        return params.data.estructura_padre0
      }
      return false
    },
  }
  const columns = [...currentColumns]
  return columns
}

const getDataColun = (filter: any) => {
  const dataColum: (ColDef | ColGroupDef)[] = [
    {
      headerName: 'Seleccionar',
      maxWidth: 150,
      cellRenderer: (params: any) => {
        return (
          <i
            style={{cursor: 'pointer'}}
            onClick={() => {
              return filter(params, false)
            }}
            className='bi bi-check-circle'
          ></i>
        )
      },
    },
    {
      field: 'rec_codigo',
      headerName: 'Código',
      maxWidth: 180,
      suppressMenu: true,
      filter: true,
      floatingFilter: true,
    },
    {
      field: 'rec_nombre',
      headerName: 'Nombre',
      minWidth: 205,
      suppressMenu: true,
      filter: true,
      floatingFilter: true,
    },
    {
      field: 'Nombretipoingprincipal',
      headerName: 'Ingrediente Principal',
      maxWidth: 210,
      suppressMenu: true,
      filter: true,
      floatingFilter: true,
    },
    {
      field: 'NombreColor',
      headerName: 'Color',
      maxWidth: 180,
      suppressMenu: true,
      filter: true,
      floatingFilter: true,
    },
    {
      field: 'NombreCosto',
      headerName: 'Costo',
      maxWidth: 180,
      suppressMenu: true,
      filter: true,
      floatingFilter: true,
    },
    {
      field: 'Idtipoingprincipal',
      headerName: 'Metodo Cocción',
      maxWidth: 180,
      suppressMenu: true,
      filter: true,
      floatingFilter: true,
    },
    {
      field: 'NombreCategorizacionCompleja',
      headerName: 'Complejidad',
      maxWidth: 180,
      suppressMenu: true,
      filter: true,
      floatingFilter: true,
    },
  ]
  return dataColum
}

export const getParameterUp = (parametersUp: any) => {
  return {
    name: 'amd_guardar_minuta',
    parametersUp: parametersUp,
  }
}

export const setParametersSaveMinuta = (
  id: string,
  id_contrato: string,
  id_minuta: string,
  id_receta: string,
  ponderacion: string,
  tipo: string = '3',
  version: string,
  fijo: string,
) => {
  return {
    parameters: [
      {
        text: 'id',
        value: id,
      },
      {
        text: 'contrato',
        value: id_contrato,
      },
      {
        text: 'id_minuta',
        value: id_minuta,
      },
      {
        text: 'id_receta',
        value: id_receta,
      },
      {
        text: 'ponderacion',
        value: ponderacion,
      },
      {
        text: 'tipo_guardado',
        value: tipo,
      },
      {
        text: 'version',
        value: version,
      },
      {
        text: 'fijo',
        value: fijo,
      },
    ],
  }
}
export const setParametersSaveComensales= (
  contrato: string,
  id_minuta: string,
  fecha: string,
  comensales: string,
  version: string,
) => {
  return {
    parameters: [
      {
        text: 'id_minuta',
        value: id_minuta,
      },
      {
        text: 'contrato',
        value: contrato,
      },
      {
        text: 'fecha',
        value: fecha,
      },
      {
        text: 'comensales',
        value: comensales,
      },
      {
        text: 'version',
        value: version,
      },
    ],
  }
}
export const setParametersSave = (
  id: string,
  id_receta: string,
  ponderacion: string,
  tipo: string = '3'
) => {
  return {
    parameters: [
      {
        text: 'id',
        value: id,
      },
      {
        text: 'id_receta',
        value: id_receta,
      },
      {
        text: 'ponderacion',
        value: ponderacion,
      },
      {
        text: 'tipo_guardado',
        value: tipo,
      },
    ],
  }
}

export const setParametersSaveValidation = (
  id: string,
  id_receta: string,
  ponderacion: string,
  tipo: string = '3',
  fijo: string = '0',
) => {
  return {
    parameters: [
      {
        text: 'id',
        value: id,
      },
      {
        text: 'id_receta',
        value: id_receta,
      },
      {
        text: 'ponderacion',
        value: ponderacion,
      },
      {
        text: 'tipo_guardado',
        value: tipo,
      },
      {
        text: 'fijo',
        value: fijo,
      },
    ],
  }
}

export const setParametersPublish = (id: string, tipo: string = '4') => {
  return {
    parameters: [
      {
        text: 'id',
        value: id,
      },
      {
        text: 'tipo_guardado',
        value: tipo,
      },
    ],
  }
}

export const minutaBackVersion = async (idContrato: any, nroVersion: any, setLoad: any) => {
  setLoad(true)
  const response: any = await callSP('amd_minutaBackVersion', [
    {text: 'contrato', value: idContrato},
    {text: 'version', value: nroVersion},
  ])
  if (response.status === 200) {
    // setDatosContrato(response.data.result)
  }
  setLoad(false)
}

export {armarColumGrid, getDataColum, getDataColun}
